import { Tag } from "antd";

import { STATUS_COLOR_MAP } from "constants/ItemFields";

const StatusTag = ({ status }) => {
  const tagColor = STATUS_COLOR_MAP[status];

  return (
    <>
      <Tag color={tagColor} style={{ margin: 0 }}>
        {status}
      </Tag>
    </>
  );
};

export default StatusTag;
